import api from '../../../api/index';

export default {
  socialLogin({ commit }, network) {
    return api
      .post('/login/callback', {
        provider: network.provider,
        accessToken: network.accessToken,
      })
      .then((response) => {
        const userData = response.data.userData || null;
        const token = response.data.token || null;
        const needDefinePassword = response.data.needDefinePassword || false;

        if (userData !== null && token !== null) {
          commit('setDadosUsuario', userData, { root: true });
          localStorage.setItem('dadosUsuario', JSON.stringify(userData));

          commit('setToken', token, { root: true });
          localStorage.setItem('token', token);

          commit('setNeedDefinePassword', needDefinePassword);
          commit('setNotification', response.data.message, { root: true });
        }
      })
      .catch((error) => {
        commit('setNotification', error.response.data.message, { root: true });
      });
  },
  sendEmail({}, email) {
    return api
      .post('/recuperar-senha', email)
  },
  restorePassword({}, data) {
    return api
      .post('/modificar-senha', data)
  },
  needDefinePassword({ commit }, need) {
    commit('setNeedDefinePassword', need);
  },
};
